import {
  IonContent,
  IonPage,
  useIonViewWillEnter,
  IonLabel,
  IonTabBar,
  IonTabButton,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import FeedItem from "../components/Feed/FeedItem";
import ProfileCard from "../components/card/ProfileCard";
import Header from "../components/layout/Header";
import {
  getProfilePosts,
  getProfileReplies,
  getVisitedProfile,
} from "../redux/actions/visitedProfileActions";
import { Helmet } from "react-helmet-async";

import { unblockUser } from "../api/requests/profile";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { username } = useParams();
  const { data, posts, replies } = useSelector((state) => state.visitedProfile);
  const { modifiedPost, newRepost } = useSelector((state) => state.post);
  const currentProfile = useSelector((state) => state.currentProfile.data);
  const [activeTab, setActiveTab] = useState("posts");

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useIonViewWillEnter(() => {
    dispatch(getVisitedProfile(username));
    if (activeTab === "posts") {
      dispatch(getProfilePosts(username));
    } else {
      dispatch(getProfileReplies(username));
    }
  }, [dispatch, username, modifiedPost, newRepost]);

  useEffect(() => {
    if (activeTab === "posts") {
      dispatch(getProfilePosts(username));
    } else {
      dispatch(getProfileReplies(username));
    }
  }, [dispatch, username, activeTab]);

  const handleUnblock = async () => {
    try {
      await unblockUser(username);
      // Refresh profile and posts after unblocking
      dispatch(getVisitedProfile(username));
      dispatch(getProfilePosts(username));
      dispatch(getProfileReplies(username));
    } catch (err) {
      console.error("Failed to unblock", err);
    }
  };

  const renderProfileHeader = () => (
    <>
      <ProfileCard
        profile={data}
        currentProfile={currentProfile?.username === username}
      />
      {data.hasBlocked ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <h2>You blocked @{data.username}</h2>
          <p>You can't see their posts or interact with them.</p>
          <button
            onClick={handleUnblock}
            style={{
              padding: "10px 20px",
              backgroundColor: "var(--main-color)",
              color: "white",
              border: "none",
              borderRadius: "20px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            Unblock
          </button>
        </div>
      ) : data.isBlockedBy ? (
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <h2>@{data.username} has blocked you.</h2>
          <p>You can't see their posts or interact with them.</p>
        </div>
      ) : null}
    </>
  );

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonContent>
          {data && (
            <div>
              {renderProfileHeader()}
              <div className="profile-tabs-container">
                <IonTabBar className="main-tabs">
                  <IonTabButton
                    tab="posts"
                    onClick={() => setActiveTab("posts")}
                    selected={activeTab === "posts"}
                  >
                    <IonLabel>Posts</IonLabel>
                  </IonTabButton>
                  <IonTabButton
                    tab="replies"
                    onClick={() => setActiveTab("replies")}
                    selected={activeTab === "replies"}
                  >
                    <IonLabel>Replies</IonLabel>
                  </IonTabButton>
                </IonTabBar>
              </div>
              {!data?.hasBlocked && !data?.isBlockedBy && (
                <>
                  {activeTab === "posts" &&
                    posts &&
                    posts.map((post, idx) => (
                      <FeedItem key={post._id} post={post} index={idx} />
                    ))}

                  {activeTab === "replies" &&
                    replies &&
                    replies.map((reply, idx) => (
                      <div key={reply._id} style={{ marginBottom: "16px" }}>
                        {reply.originalPost ? (
                          <div
                            style={{
                              position: "relative",
                              marginBottom: "8px",
                            }}
                          >
                            <FeedItem
                              post={reply.originalPost}
                              replyOriginalPost
                            />

                            <FeedItem
                              post={{ ...reply, originalPost: null }}
                              index={idx}
                            />
                          </div>
                        ) : (
                          <FeedItem post={reply} index={idx} />
                        )}
                      </div>
                    ))}
                </>
              )}
            </div>
          )}
        </IonContent>
      </IonPage>
    </>
  );
};

export default Profile;

